import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { buyers } from '../data/buyers';
import { MOCKUP_URL } from '../data/offer';
type Notice = {
  name: string;
  country: string;
  minutesAgo: number;
};
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const INTERVAL = 15000;
export function PurchasePopup() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let index = Math.floor(Math.random() * buyers.length);
    let hideTimer: number | undefined;
    const show = () => {
      const buyer = buyers[index % buyers.length];
      index += 1;
      setNotice({
        ...buyer,
        minutesAgo: 1 + Math.floor(Math.random() * 12)
      });
      hideTimer = window.setTimeout(() => setNotice(null), VISIBLE_FOR);
    };
    const first = window.setTimeout(show, FIRST_DELAY);
    const loop = window.setInterval(show, INTERVAL);
    return () => {
      window.clearTimeout(first);
      window.clearInterval(loop);
      if (hideTimer) window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  return <div className="pointer-events-none fixed bottom-[92px] left-3 right-3 z-50 sm:bottom-6 sm:left-6 sm:right-auto" aria-live="polite" data-id="element-44" data-mp="1fur09zkpz5pc">
      <AnimatePresence data-id="element-45" data-mp="1aysiiutwclxw">
        {notice && !dismissed && <motion.div key={`${notice.name}-${notice.minutesAgo}`} className="pointer-events-auto flex w-full max-w-[340px] items-center gap-3 rounded-2xl bg-white p-2.5 pr-3 shadow-[0_12px_32px_rgba(5,15,44,0.25)] ring-1 ring-navy-900/10" initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-46" data-mp="n868wz48utls">
            <img src={MOCKUP_URL} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-mist object-contain p-1" data-id="element-47" data-mp="23kldwjcv4yan" />
            <div className="min-w-0 flex-1" data-id="element-48" data-mp="2ao1qz900i9v1">
              <p className="truncate text-sm font-bold text-ink" data-id="element-49" data-mp="2fne9xinriwsc">
                {notice.name} <span className="font-medium text-ink/60" data-id="element-50" data-mp="2fph66kfidm5i">from {notice.country}</span>
              </p>
              <p className="text-[13px] leading-snug text-ink/75" data-id="element-51" data-mp="2plu0nkivo41b">just purchased Maxillary Growth Blueprint™</p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] font-semibold text-success" data-id="element-52" data-mp="1rybvejofdk22">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-53" data-mp="1wwwtodk49tnv" />
                {notice.minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="self-start rounded-md p-1 text-ink/40 transition-colors duration-150 hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-electric" aria-label="Dismiss notification" data-id="element-54" data-mp="21uycqyhjlszc">
              <XIcon className="h-4 w-4" data-id="element-55" data-mp="3rhgkj5f782zo" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}